import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { GalaxyPipesModule } from '@vendasta/galaxy/pipes';
import { PageComponent } from '../common/page.component';
import { TermsOfServiceComponent } from './terms-of-service.component';
import { TermsOfServiceService } from './terms-of-service.service';
import { GalaxyPageModule } from '@vendasta/galaxy/page';

@NgModule({
  imports: [
    CommonModule,
    MatProgressSpinnerModule,
    MatCardModule,
    MatCheckboxModule,
    MatButtonModule,
    GalaxyPipesModule,
    PageComponent,
    GalaxyPageModule,
  ],
  exports: [TermsOfServiceComponent],
  declarations: [TermsOfServiceComponent],
  providers: [TermsOfServiceService],
})
export class TermsOfServiceModule {}
